const state = {
    resourceTypes: [
        {
          name: '场景',
          key: 'scene',
          content: 'sceneContent',
          icon: 'iconchangjing',
          index: 0,
          shelter: false,
          queue: null
        },
        {
          name: '模板',
          key: 'template',
          content: 'templateContent',
          svgUrl: '../../static/svg/resources-area/template-icon.svg',
          index: 1,
          shelter: false,
          queue: null
        },
        {
          name: '背景',
          key: 'bg',
          content: 'bgContent',
          icon: 'iconbeijing',
          index: 2,
          shelter: false,
          queue: null
        },
        {
          name: '文字',
          key: 'word',
          content: 'wordContent',
          svgUrl: '../../static/svg/resources-area/word-icon.svg',
          index: 3,
          shelter: false,
          queue: null
        },
        {
          name: '角色',
          key: 'role',
          content: 'roleContent',
          icon: 'iconjiaose',
          index: 4,
          shelter: false,
          queue: null
        },
        {
          name: '素材',
          key: 'visual',
          content: 'visualContent',
          icon: 'icondaoju',
          index: 5,
          shelter: false,
          queue: null
        },
        {
          name: '音乐',
          key: 'music',
          content: 'musicContent',
          icon: 'iconyinle1',
          index: 6,
          shelter: false,
          queue: null
        },
        {
          name: '上传',
          key: 'mine',
          content: 'mineContent',
          icon: 'iconwode',
          index: 7,
          shelter: false,
          queue: null
        }
      ],
    choosedResourceType: {
        name: '场景',
        key: 'scene',
        content: 'sceneContent',
        icon: 'iconchangjing',
        index: 0,
        shelter: false,
        queue: null
    },
    paneStatus: 'pane-enter',
    sceneLibStatus: '',
    isShowScenesLoading: true,
};
const getters = {
    getResourceTypes: (state) => state.resourceTypes,
    getChoosedResourceType: (state) => state.choosedResourceType,
    getPaneStatus: (state) => state.paneStatus,
    getSceneLib: (state) => state.sceneLibStatus,
    isShowScenesLoading: state => state.isShowScenesLoading
};
const mutations = {
    setResourceTypes (state, data) {
      state.resourceTypes[data.index] = Object.assign(state.resourceTypes[data.index], data.data);
    },
    setShelters (state, data) {
        state.resourceTypes.forEach((item) => {
            item.shelter = true;
        });
        data.forEach((item) => {
            state.resourceTypes[item].shelter = false;
        });
    },
    setChoosedResourceType (state, data) {
        state.choosedResourceType = data;
        state.sceneLibStatus = '';
    },
    setPaneStatus (state, data) {
        state.paneStatus = data;
    },
    setSceneLibStatus (state, data) {
        state.sceneLibStatus = data;
    },
    isShowScenesLoading (state, data) {
      state.isShowScenesLoading = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/materialArea.js